<template>
  <div id="featurepad" class="d-flex flex-column fill-width " fill-height style="background-color: rgb(33,33,33);"
      v-if="selectedOLFeature">

    <div id="ribbon" class="pa-0 ma-0" fill-width></div>



    <v-card class="flex-grow-1 pt-4" theme="light">
      <v-card-actions theme="dark" class="justify-center bg-grey-darken-4" v-if="isFeatureNew">
        <v-btn variant="outlined" color="white" size="large" @click="cancelNewItem" class="ma-2">
          <v-icon class="mr-2" color="red">mdi-close</v-icon>
          Annulla inserimento</v-btn>
      </v-card-actions>

      <v-card-title id="cardTitleStyle">
        <!-- <v-icon v-if="formIsDisabled" class="mr-2 mt-n3" size="x-small" color="#CCC">mdi-eye</v-icon>
        <v-icon v-else class="mr-2 mt-n3" size="x-small" color="#CCC">mdi-pencil</v-icon> -->
        <div class="d-flex">
          <p class="text-headline-large">
            <v-icon size="x-small" color="grey" class="mb-2">mdi-{{ possibilitaAttiva?.mdiIcon || 'hamburger' }}</v-icon>
            {{ possibilitaAttiva?.descrizione || "descrizione non presente" }}
          </p>
          <v-spacer />
          <template v-if="runtimeStore.session.user.groups.includes('ufficio_botanico')">
          </template>
        </div>
      </v-card-title>
      <!-- <v-card-subtitle v-if="formIsDisabled" :class="`ma-0 bg-grey-darken-2 text-white`">
        <p class="text-title-large"><v-icon size="small">mdi-eye</v-icon>Consultazione</p>
      </v-card-subtitle> -->
      <v-card-subtitle v-if="formIsDisabled" class="ma-0">
        <v-icon size="x-small" color="blue-darken-3" class="ml-2">mdi-eye</v-icon> <span
            class="text-blue-darken-3 font-weight-bold">Consultazione</span>
      </v-card-subtitle>

      <v-card-text>
        <v-form :readonly="formIsDisabled">
          <v-container fill-height fluid absolute class="pa-0 pt-5 pa-md-5">
            <v-row justify="center">
              <v-col class="fluid-column">

                <component :is="component" v-model="properties" @update:modelValue="modelUpdatedDisabled"
                    :isNew="isFeatureNew" />
                <!-- :extra="possibilitaAttiva.props" /> -->



                <div v-if="foundDataFeatureAndNode">

                  <p class="mb-3 d-flex">

                    <span class="text-headline-small">
                      Raw data
                    </span>
                    <v-btn @click="toggleShowRaw" class="mx-3 pa-2" size="" color="primary">
                      <v-icon v-if="showRaw == 0" size="">mdi-eye-off</v-icon>
                      <v-icon v-else size="">mdi-data-matrix</v-icon>
                    </v-btn>
                    <v-spacer />
                  </p>
                  <v-expansion-panels flat variant="accordion" class="fill-width" v-model="showRaw">
                    <v-expansion-panel>
                      <template v-slot:text>

                        <v-btn @click="downloadDataCSV" download
                            :color="possibilitaAttiva?.color || 'black'" class="ml-0 pa-2" size="">
                          <v-icon size="x-small" class="mr-1">mdi-file-download</v-icon> csv
                        </v-btn>
                        <v-btn @click="downloadDataJSON" download
                            :color="possibilitaAttiva?.color || 'black'" class="ml-3 pa-2" size="">
                          <v-icon size="x-small" class="mr-1">mdi-file-download</v-icon> json
                        </v-btn>
                        <pre class="mt-3">{{ properties }}</pre>
                      </template>
                    </v-expansion-panel>
                  </v-expansion-panels>

                  <p class="mb-3">
                    <span class="text-headline-small">
                      Sincronia
                      : {{ properties?.state || "Null" }}</span>
                      
                      <v-btn  size="" @click="toggleStatusesInfo" variant="text" class="ml-2 mb-1">
                        <v-icon size="large" color="grey">mdi-information</v-icon>
                      </v-btn>
                    <div v-if="showStatusesInfo">
                      <v-divider />
                      <p class="">
                        Legenda
                      </p>
                        <ul class="pl-6">
                          <li><strong>Null</strong><br>Nessun tentativo di sincronizzazione effettuato.</li>
                          <li><strong>201</strong> - Created <br>Contenuto inviato e registrato con successo.</li>
                          <li><strong>409</strong> - Conflict <br>Contenuto non recepibile dal server a causa di un conflitto con dati già presenti.</li>
                          <li><strong>422</strong> - Unprocessable Entity <br>Contenuto non compatibile con i dati aspettati dal server.</li>
                          <li><strong>500</strong> - Internal Server Error <br>Errore del server, riprovare in seguito</li>
                          
                        </ul>

                    </div>
                    <v-divider />

                    <div v-if="ENVIRONMENT==='development'">
                    <div class="text-title-large">
                      <v-icon class="mr-1">mdi-state-machine</v-icon>
                      Set to:
                      </div>
                      <v-btn @click="setStatusTo(null)" color="grey-darken-3" class="ma-2" size="small">
                        <v-icon class="mr-1">mdi-null</v-icon> null
                      </v-btn><br>
                      <v-btn @click="setStatusTo(201)" color="success" class="ma-2" size="small">
                        <v-icon class="mr-1">mdi-check</v-icon> 201
                      </v-btn><br>
                      <v-btn @click="setStatusTo(422)" color="orange" class="ma-2" size="small">
                        <v-icon class="mr-1">mdi-alert</v-icon> 422
                      </v-btn><br>
                      <v-btn @click="setStatusTo(500)" color="error" class="ma-2" size="small">
                        <v-icon class="mr-1">mdi-alert-circle</v-icon> 500
                      </v-btn><br>
                    </div>


                    <v-btn v-if="properties?.state === 422" @click="setStatusTo(null)" color="primary" class="ml-3 mt-2" size="x-small">
                      <v-icon size="x-small" class="mr-1">mdi-state-machine</v-icon> set to null
                    </v-btn><br>
                  </p>


                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-form>

      </v-card-text>
    </v-card>

    <v-card id="actions" theme="dark" flat class="rounded-0">
      <v-card-actions class="justify-center" v-if="formIsDisabled">
        <v-btn variant="outlined" color="white" size="x-large" @click="backToMap" class="ma-2">
          <v-icon class="mr-2">mdi-chevron-down</v-icon>
          Indietro</v-btn>
      </v-card-actions>
      <v-card-actions class="justify-center" v-else>

        <template v-if="showPlusOne()">
          <v-btn variant="outlined" color="white" size="x-large" class="ma-2 mr-4" @click="addOne">
            <v-icon class="mr-2" color="yellow">mdi-content-copy</v-icon>
            Copia</v-btn>
        </template>

        <v-btn variant="outlined" color="white" size="x-large" @click="backToMap" class="ma-2">
          <v-icon class="mr-2" color="green">mdi-check</v-icon>
          Conferma</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script setup>



import { ref, computed, markRaw, onMounted, onUnmounted, watch, nextTick } from "vue"
import { useDataStore } from "@/store/data"
import { useRuntimeStore } from "@/store/runtime"
import { useToastsStore } from "@/store/toasts";

import PhytoSocioLogical from "@/reports/PhytoSocioLogical"
import SegnalazioneFauna from "@/reports/SegnalazioneFauna"
import SegnalazioneFlora from "@/reports/SegnalazioneFlora"
import SegnalazioneGenerica from "@/reports/SegnalazioneGenerica"
import SegnalazioneGipeto from "@/reports/SegnalazioneGipeto"
import SegnalazionePuntointeresse from "@/reports/SegnalazionePuntointeresse"
import SegnalazioneLupo from "@/reports/SegnalazioneLupo"
import SegnalazioneMarcati from "@/reports/SegnalazioneMarcati"
import SegnalazionePersona from "@/reports/SegnalazionePersona"
import SegnalazioneAnnotazione from "@/reports/SegnalazioneAnnotazione"
import SegnalazioneTabellazione from "@/reports/SegnalazioneTabellazione"
import SegnalazioneVeicolo from "@/reports/SegnalazioneVeicolo"
import Segmento from "@/reports/Segmento"
import SegmentoLupo from "@/reports/SegmentoLupo"
import SegmentoDescritto from "@/reports/SegmentoDescritto"
import SegmentoManutenzione from "@/reports/SegmentoManutenzione"
import SegmentoFronteGhiacciaio from "@/reports/SegmentoFronteGhiacciaio"
import SegnalazionePoligonoMonticanti from "@/reports/SegnalazionePoligonoMonticanti"
import SegnalazionePoligonoDanni from "@/reports/SegnalazionePoligonoDanni"




import { json2csv } from 'json-2-csv';

import router from "@/router";
import { useRoute } from 'vue-router'
// import { set } from "ol/transform"

const runtimeStore = useRuntimeStore();
const toastsStore = useToastsStore();

const props = defineProps(
  ["vectorSelectionControl", "currentCenter", "map", "selectedOLFeature", "layerOfSelectedFeature"])

const emit = defineEmits(['onBackButtonIfFeatureIsNew'])


const showRaw = ref(null)
const toggleShowRaw = () => {
  if (showRaw.value === null) {
    showRaw.value = 0
    return
  } else {
    showRaw.value = null
  }
}

const showStatusesInfo= ref(false)

const toggleStatusesInfo = () => {
  showStatusesInfo.value = !showStatusesInfo.value
}
const setStatusTo = (newStatus) => {
  properties.value.state = newStatus
}


const possibilitaAttiva = computed(() => {
  if (!properties.value) return {
    color: "#CCCCCC",
    descrizione: "descrizione non presente"
  }
  // debugger
  let p = dataStore.ventaglio_possibili.find((item) => item.id == properties.value.possibilita_id)
  if (!p) {
    dataStore.ventaglio_possibili.find((item) => item.modelCamel == properties.value.model)
  }
  return p
})

const route = useRoute()
const dataStore = useDataStore()

// const dialogDismiss = ref(false)

const backToMap = () => {
  clearNewSetUUIDTimeoutID && clearTimeout(clearNewSetUUIDTimeoutID)
  router.push({ name: "map" })
}


const addOne = async () => {

  const justCopiedFeature = dataStore.copyTrackerFeature(properties.value.uuid)

  await nextTick()

  router.push(
    {
      name: "tracker-feature-edit",
      query: {
        uuid: justCopiedFeature.properties.uuid,
        new: true
      }
    });

  toastsStore.toast({
    title: 'Copia in posizione',
    text: 'Hai effettuato la copia dell\'elemento che era attivo.\n\n<strong>In questo momento stai modificando il nuovo elemento.</strong>',
    type: 'success',
    duration: 6000,
  })

}


let formIsDisabled = true
if (route.name == "tracker-feature-edit") {
  formIsDisabled = false
}


const lookupFormComponents = {
  PhytoSociological: markRaw(PhytoSocioLogical),
  SegnalazioneFauna: markRaw(SegnalazioneFauna),
  SegnalazioneFlora: markRaw(SegnalazioneFlora),
  SegnalazioneGenerica: markRaw(SegnalazioneGenerica),
  SegnalazioneGipeto: markRaw(SegnalazioneGipeto),
  SegnalazionePuntointeresse: markRaw(SegnalazionePuntointeresse),
  SegnalazioneLupo: markRaw(SegnalazioneLupo),
  SegnalazioneMarcati: markRaw(SegnalazioneMarcati),
  SegnalazionePersona: markRaw(SegnalazionePersona),
  SegnalazioneAnnotazione: markRaw(SegnalazioneAnnotazione),
  SegnalazioneTabellazione: markRaw(SegnalazioneTabellazione),
  SegnalazioneVeicolo: markRaw(SegnalazioneVeicolo),

  Segmento: markRaw(Segmento),
  SegmentoLupo: markRaw(SegmentoLupo),
  SegmentoDescritto: markRaw(SegmentoDescritto),
  SegmentoManutenzione: markRaw(SegmentoManutenzione),
  SegmentoFronteGhiacciaio: markRaw(SegmentoFronteGhiacciaio),

  SegnalazionePoligonoMonticanti: markRaw(SegnalazionePoligonoMonticanti),
  SegnalazionePoligonoDanni: markRaw(SegnalazionePoligonoDanni),

  
  
}



const downloadDataJSON = async () => {
  const data = btoa(JSON.stringify(properties.value, null, 2))
  const downloadLink = document.createElement("a")

  const filename = `data-${properties.value.model}-${properties.value.real_timestamp}.json`
  downloadLink.download = filename
  downloadLink.innerHTML = "download feature data"
  downloadLink.href = "data:text/json;base64," + data
  downloadLink.click()
  downloadLink.remove()
}



const showPlusOne = () => {
  let show = false
  if (
    runtimeStore.session.user.groups.includes('ufficio_botanico')
    && properties?.value?.model === "SegnalazioneFlora"
    // && isFeatureNew.value
  )
    show = true
  return show
}

const downloadDataCSV = async () => {

  // const csv = await json2csv(data, options)
  let csv = ""
  if (properties.value.model == "PhytoSociological") {

    const general_data = JSON.parse(JSON.stringify(properties.value, null, 2))
    delete general_data.taxa

    const phytosociological_data = JSON.parse(JSON.stringify(properties.value.taxa, null, 2))

    for (const taxa of phytosociological_data) {
      Object.assign(taxa, general_data)
    }

    csv = await json2csv(phytosociological_data)
  }
  else {
    csv = await json2csv(properties.value)
  }
  console.log(csv)

  const data = btoa(csv)
  const downloadLink = document.createElement("a")

  const filename = `data-${properties.value.model}-${properties.value.real_timestamp}.csv`
  downloadLink.download = filename
  downloadLink.innerHTML = "download feature data"
  downloadLink.href = "data:text/json;base64," + data
  downloadLink.click()
  downloadLink.remove()
}




const modelUpdatedDisabled = (async () => {
})


const modelUpdated = (async () => {
  dataStore.save()
})



const properties = ref(null)
const foundDataFeatureAndNode = ref(null)
const isFeatureNew = ref(false)



onMounted(() => {

  // debugger

  console.log("📍 selectedOLFeature", props.selectedOLFeature)
  // console.log("❗️ calcolare un label per la feature, a seconda del model e utilizzarlo in mappa")


  loadData()
  manageUrlParams()
  addEventForBackButton()

})

onUnmounted(() => {
  removeEventForBackButton()
})


const cancelNewItem = (event) => {
  emit('onBackButtonIfFeatureIsNew', properties.value.uuid)
}



const triggerDeleteConfirmation = (event) => {
  console.log(event)
  emit('onBackButtonIfFeatureIsNew', properties.value.uuid)
  // return confirm("asd","yes","no")
}

const addEventForBackButton = () => {
  if (isFeatureNew.value) {
    console.log("addEventForBackButton")
    console.log(isFeatureNew.value)
    window.addEventListener("popstate", triggerDeleteConfirmation)
  }
}

const removeEventForBackButton = () => {
  if (isFeatureNew.value) {
    console.log("removeEventForBackButton")
    console.log(isFeatureNew.value)
    window.removeEventListener("popstate", triggerDeleteConfirmation)
  }
}





// const featureTemporaryData = ref(null)


const component = ref(null)


const loadData = async () => {

  await nextTick()
  
  foundDataFeatureAndNode.value = dataStore.getDataFeatureFromOLFeature(props.selectedOLFeature, props.layerOfSelectedFeature)

  // console.log(foundDataFeatureAndNode)

  // console.log(" ================================== ==================================")
  // console.log(props.selectedOLFeature)
  // const featuredata = ref(null) // get ref feature from right level in dataStore

  if (!foundDataFeatureAndNode.value) {
    console.log(props.selectedOLFeature)
    console.log("foundDataFeatureAndNode not found")
    console.log("go back??? to /map/")
    backToMap()
    return
  }

  properties.value = foundDataFeatureAndNode.value.feature.properties

  component.value = lookupFormComponents[foundDataFeatureAndNode.value.feature.properties.model]

}

let clearNewSetUUIDTimeoutID = null

const clearNewSetUUID = () => {
  router.push({
    query: { uuid: properties.value.uuid }
  })
}


const manageUrlParams = async () => {

  console.log("remember to zoom to feature")

  const urlParams = new URLSearchParams(window.location.search);
  isFeatureNew.value = urlParams.get('new') === "true"

  if (isFeatureNew.value) {
    console.log("🆕 new feature, redirect to same url without new=true")
    // window.history.pushState({}, document.title, window.location.pathname);

    clearNewSetUUIDTimeoutID = setTimeout(clearNewSetUUID, 100)

  }
  else {
    console.log("🔍 existing feature")
  }

}




// watch(properties, () => {
watch(properties, (newVal, oldVal) => {
  // magic happens here
  modelUpdated()
}, { deep: true }
)


</script>

<style scoped>
#ribbon {
  height: 2em;
  width: 100%;
  z-index: 1004;
  position: fixed;
  border-width: 1em 0 0 0;
  border-style: solid;
  border-color: v-bind('possibilitaAttiva?.color || "black"');
}


#featurepad {
  position: absolute;
  background: white;
  top: 0;
  left: 0;
  min-height: 100%;
  width: 100%;
  z-index: 1005;
}

#actions {
  width: 100%;
  justify-content: center;
  align-items: center;
  position: sticky;
  bottom: 0;
  z-index: 1006;
}

#deleteactions {
  width: 100%;
  justify-content: center;
  align-items: center;
}
</style>
